'use client'

import {getGameWindow} from '@app/components/game-player/helper'
import SharePopup from '@app/components/gameplayer-page/actions-section/buttons/share-btn/share-action/share-popup'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {useEffect, useState} from 'react'

type Props = {
  gameUrl: string
  gameNameEn: string
  gameCode: string
}

export const triggerShareAnalytics = ({
  gameCode,
  gameNameEn,
  shareSource,
  isNativeShare,
}: {
  gameCode: string
  gameNameEn: string
  shareSource: 'game' | 'portal'
  isNativeShare: boolean
}) => {
  triggerAnalytics('share-popup-shown', {
    'game-name': gameNameEn,
    'game-code': gameCode,
    'share-source': shareSource,
    'is-share-native': isNativeShare,
  }).sendAll()
}

const ShareHandler = ({gameUrl, gameNameEn, gameCode}: Props) => {
  const [shareUrl, setShareUrl] = useState(gameUrl)
  const [isShareMenuOpen, setIsShareMenuOpen] = useState(false)

  useEffect(() => {
    const triggerShareMenu = (urlToShare: string) => {
      let isNativeShare = true
      if (window.navigator.share) {
        window.navigator.share({
          url: urlToShare,
        })
      } else {
        isNativeShare = false
        setIsShareMenuOpen(true)
      }
      triggerShareAnalytics({
        gameCode,
        gameNameEn,
        shareSource: 'game',
        isNativeShare,
      })
    }

    const handleMessageEvent = (event: MessageEvent) => {
      const eventData = event.data
      const {name} = eventData

      if (name === 'shareGame') {
        const game = getGameWindow()
        const newShareUrl = gameUrl + `?entryData=${window.btoa(JSON.stringify(game?.gamezop?.entryPointData))}`
        setShareUrl(newShareUrl)
        triggerShareMenu(newShareUrl)
      }
    }

    window.addEventListener('message', handleMessageEvent)
    return () => {
      window.removeEventListener('message', handleMessageEvent)
    }
  }, [])

  return (
    <SharePopup
      shareData={{
        url: shareUrl,
      }}
      isOpen={isShareMenuOpen}
      setIsOpen={setIsShareMenuOpen}
    />
  )
}

export default ShareHandler
